// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log("Visit the guide for more information: ", "https://vite-ruby.netlify.app/guide/rails");

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// 同意チェックの活性化は相談・登録導線の必須要素のため、jQuery 依存を持つ home/index の
// 評価失敗に巻き込まれないよう最初に評価する
import "@/application/didCheckAgree";
import "@/application/home/index";
import "@/application/native_dialog";
import "../../app/components/shared/anytime_consultations/quick_satisfaction_survey_component";
import { bootstrapRum } from "@/observability/rum/bootstrap";

// legacy配下に移動したいが、影響範囲の特定ができていないため、一旦ここに記載
import "@/application/anytime_consultations/new";

// Datadog RUM を初期化する
// 環境別フラグが OFF または対象外パスの場合は no-op で終了する
bootstrapRum();
